export const TYPE_STRUCTURE_PRIVEE = "STRUCTURE_PRIVE";
export const TYPE_DIRECTION = "DIRECTION";
export const TYPE_ORGANISATION_PUBLIC = "ORGANISATION_PUBLIC";
export const TYPE_STRUCTURE_PRIVEE_VALUE = "STRUCTURE PRIVEE";
